<template>
  <div id="lesions-content" :class="classes">
    <div class="mri-images">
      <transition name="fade">
        <img
          src="../assets/img/axial-brain.png"
          alt="Brain model showing horizontal (axial) plane cut, to indicate axial M R I image."
        />
        <!-- <img src="../assets/img/brain_2.svg" v-if="stage === 'early-rrms'" alt="Simulated brain M R I, with 3 small lesions on the right side." />
      <img src="../assets/img/brain_3.svg" v-if="stage === 'late-rrms'" alt="Simulated brain M R I, with 3 small lesions on the right side, 1 small lesion on the left, and 1 larger lesion posteriorly on each of the left and right sides." />
      <img src="../assets/img/brain_4.svg" v-if="stage === 'spms'" alt="Simulated brain M R I, with multiple diffuse lesions, including 3 small lesions on the right side, 1 small lesion on the left, and 1 larger lesion posteriorly on each of the left and right sides." /> -->
      </transition>
      <div id="lesions-copy">
        <transition name="fade">
          <h4 v-if="stage !== 'healthy'">Lesions</h4>
        </transition>
        <transition name="fade">
          <p class="early-rrms" v-if="stage === 'early-rrms'">
            In the early stages (RRMS), pathology is dominated by focal
            inflammatory lesions. Some subthreshold lesions do not manifest
            clinically.<sup>1,8</sup>
          </p>
          <p class="late-rrms" v-if="stage === 'late-rrms'">
            Neuronal damage following focal axonal lesions include axon
            degeneration and atrophy of neuronal cell bodies and dendrites.<sup
              >2</sup
            >
          </p>
          <p class="spms" v-if="stage === 'spms'">
            In SPMS, diffuse pathological features are more prominent in the
            white and grey matter, including microglial activation and
            neurodegeneration on cortical histopathology.<sup>8</sup>
          </p>
        </transition>
      </div>

      <Modal v-if="$store.state.showModal !== ''">
        <div class="lesions-copy" slot="content">
          <h1>Lesions</h1>
          <p class="early-rrms" v-if="stage === 'early-rrms'">
            In the early stages (RRMS), pathology is dominated by focal
            inflammatory lesions. Some subthreshold lesions do not manifest
            clinically.<sup>1,8</sup>
          </p>
          <p class="late-rrms" v-if="stage === 'late-rrms'">
            Neuronal damage following focal axonal lesions include axon
            degeneration and atrophy of neuronal cell bodies and dendrites.<sup
              >2</sup
            >
          </p>
          <p class="spms" v-if="stage === 'spms'">
            In SPMS, diffuse pathological features are more prominent in the
            white and grey matter, including microglial activation and
            neurodegeneration on cortical histopathology.<sup>8</sup>
          </p>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import progressionMixin from "@/mixins/progressionMixin";
import Modal from "@/components/Modal.vue";

export default {
  name: "LesionsContent",
  props: ["classes"],
  mixins: [progressionMixin],
  components: {
    Modal,
  },
};
</script>

<style lang="scss">
#lesions-content {
  position: absolute;
  left: 00px;
  top: 100px;
  display: block;
  width: 54%;
  @include breakpoint(lg) {
    width: 75%;
    top: 115px;
    left: -55px;
  }
  @include breakpoint(md) {
    width: 55%;
    top: 100px;
    left: -40px;
  }
  @include breakpoint(xs) {
    top: 60px;
    left: -30px;
    // right: 50px;
  }
  @media (max-width: 600px) {
    width: 50%;
    left: -10px;
    // right: 35px;
    top: 55px;
  }
  @media (max-width: 450px) {
    right: 20px;
    top: 80px;
  }
  .mri-images {
    width: 100%;
    text-align: center;
    padding: 10px;

    img {
      display: inline-block;
      width: 50%;
      height: auto;
      @media (max-width: 600px) {
        width: 75%;
      }
      @media (max-width: 450px) {
        width: 80%;
      }
    }
  }

  h4 {
    margin: 10px 0;
  }

  p {
    font-size: rem(10px);
    line-height: 1.2;
  }

  &.relative {
    position: relative;
    right: auto;
    top: 0;
    width: 100%;

    p {
      font-size: rem(16px);
    }
  }
}
#lesions-copy {
  margin-top: 30px;
  text-align: left;
  @include breakpoint(xs) {
    display: none;
  }
  @include breakpoint(lg) {
    // display: none;
    width: 75%;
  }
}
.lesions-copy {
  text-align: left;
}
</style>
